import { IonText } from '@ionic/react';
import { CaretDownIcon, CaretRightIcon, CaretUpIcon } from '../../theme/Icons';
import { IThemeColor } from '../../theme/IThemeColor';
import { ReactNode } from 'react';

export interface IChangeIndicatorProps {
    direction: 'up' | 'down' | 'flat';
    value?: string | ReactNode;
    color?: IThemeColor;
}

export const ChangeIndicator: React.FC<IChangeIndicatorProps> = ({ direction, value, color }) => {

    const Icon = (direction === 'up' ? CaretUpIcon : direction === 'down' ? CaretDownIcon : CaretRightIcon);

    return (
        <div data-type="change-indicator" style={{display: 'flex', alignItems: 'center', gap: 3, height: 15}}>
            <Icon color={color || 'medium'} size="small" />
            {value &&
                <IonText data-type="change-value" color={color} style={{fontSize: 12}}>{value}</IonText>
            }
        </div>
    );
};
